import React from 'react';
import { siteContent } from '../data/mock';

const AuthoritySection = () => {
  const { authority } = siteContent;

  return (
    <section className="authority-section section-padding" data-testid="authority-section" data-reveal="subtle">
      <div className="container">
        <div className="authority-content">
          {authority.paragraphs.map((paragraph, index) => (
            <p
              key={index}
              className={`authority-paragraph ${index === 2 ? 'authority-verse' : ''}`}
              data-testid={`authority-paragraph-${index}`}
            >
              {paragraph}
            </p>
          ))}
          <p className="authority-closing" data-testid="authority-closing">
            {authority.closingLine}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AuthoritySection;
